<template>
  <el-card shadow="always" v-if="state == 'CHANGED'">
    <div slot="header" class="clearfix">
      <span>Contato</span>
    </div>
    <div>
      <el-form ref="form" :model="contactForm" :rules="rules" :label-position="labelPosition" label-width="180px">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item class="no-margin-bottom" :label="$t('aos-cuidados')">
              <el-input v-model="contactForm.care" maxlength="57"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item :label="$t('cpf/cnpj')" prop="federalid">
              <el-input v-model="contactForm.federalid" v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item class="no-margin-bottom" :label="$t('inscricao-estadual')" prop="stateRegistration">
              <el-input v-model="contactForm.stateRegistration" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item class="no-margin-bottom" :label="$t('telefone')" prop="phone">
              <el-input v-model="contactForm.phone" v-mask="['(##) ####-####', '(##) #####-####']"></el-input>
              <el-checkbox v-model="contactForm.whatsapp">Receber notificações no Whatsapp</el-checkbox>

            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="18" :lg="24" :xl="24">
            <el-form-item class="no-margin-bottom" :label="$t('email')">
              <el-input maxlength="50" v-model="contactForm.mail"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item class="no-margin-bottom" :label="$t('pedido')">
              <el-input maxlength="100" v-model="contactForm.request"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item class="no-margin-bottom" :label="$t('observacao')">
              <el-input type="textarea" :rows="3" maxlength="100" show-word-limit v-model="contactForm.observation"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-card>
  <el-card v-else shadow="always" style="min-height: 143px">
    <el-row :gutter="5">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <label style="font-weight: bold">Telefone:</label>&nbsp;
        <label>{{ contactForm.phone }} </label>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="18" :sm="18" :md="18" :lg="6" :xl="6">
        <label style="font-weight: bold">E-mail:</label>&nbsp;
        <label>{{ contactForm.mail }} </label>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
        <label style="font-weight: bold">Aos cuidados:</label>&nbsp;
        <label>{{ contactForm.care }} </label>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
        <el-button type="info" @click="changed" size="mini">Alterar</el-button>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { CnpjHelpers } from "@/xpost/helpers/cnpj";
import { CpfHelpers } from "@/xpost/helpers/cpf";

const checkFederalid = (rule, value, callback) => {
  const raw = String(value || "").trim();
  if (!raw) return callback(new Error(i18n.tc("cpf-cnpj-obrigatorio")));
  if (raw.length === 14) return CpfHelpers.checkCpf(rule, raw, callback);
  if (raw.length === 18) return CnpjHelpers.checkCnpj(rule, raw, callback);
  return callback(new Error(i18n.tc("cpf-cnpj-invalido")));
};

export default {
  name: "PrePostContact",
  props: ["state", "labelPosition", "malha"],
  computed: {
    // `required` marca o asterisco no rótulo; telefone só é obrigatório para cliente de malha
    rules() {
      return {
        federalid: [{ required: true, validator: checkFederalid, trigger: "blur" }],
        phone: this.malha
          ? [{ required: true, message: i18n.tc("telefone-obrigatorio-malha"), trigger: "blur" }]
          : [],
      };
    },
  },
  methods: {
    // Promise<string[]>: mensagens dos campos inválidos (vazio = tudo certo). Além do erro
    // inline sob o campo, a tela lista os nomes no aviso — o formulário é grande demais para adivinhar.
    validate() {
      if (!this.$refs.form) return Promise.resolve([]);
      return new Promise((resolve) => {
        this.$refs.form.validate((valid, invalidFields) => {
          if (valid) return resolve([]);
          const messages = [];
          Object.keys(invalidFields || {}).forEach((field) => {
            (invalidFields[field] || []).forEach((error) => messages.push(error.message));
          });
          resolve(messages);
        });
      });
    },
    changed() {
      const vm = this;
      vm.$emit("changed");
    },
    clear() {
      const vm = this;
      vm.contactForm.save = false;
      vm.contactForm.invoice = "";
      vm.contactForm.request = "";
      vm.contactForm.federalid = "";
      vm.contactForm.stateRegistration = "";
      vm.contactForm.care = "";
      vm.contactForm.mail = "";
      vm.contactForm.phone = "";
      vm.contactForm.observation = "";
      vm.contactForm.whatsapp = true;
    },
  },
  data() {
    return {
      loading: false,
      contactForm: {
        save: false,
        invoice: "",
        request: "",
        care: "",
        mail: "",
        phone: "",
        federalid: "",
        stateRegistration: "",
        observation: "",
        whatsapp: true,
      },
    };
  },
};
</script>


<style>
.no-margin-bottom {
  margin-bottom: 0px !important;
}
</style>